import { ApiQuickStatusComment } from '../../../api/models';
import { createSlice } from '@reduxjs/toolkit';

export interface QuickStatusCommentsState {
  quickComments: ApiQuickStatusComment[] | null;
  loadingComments: boolean;
}

export const initialState: QuickStatusCommentsState = {
  quickComments: null,
  loadingComments: false,
};

const statusCommentsSlice = createSlice({
  name: 'statusComments',
  initialState,
  reducers: {
    fetchQuickStatusCommentsSuccess: (state, action) => {
      state.quickComments = action.payload;
      state.loadingComments = false;
    },
    fetchQuickStatusCommentsFailure: (state) => {
      state.quickComments = initialState.quickComments;
      state.loadingComments = false;
    },
    setLoadingComments: (state, action) => {
      state.loadingComments = action.payload;
    },
    sortQuickStatusCommentsSuccess: (state, action) => {
      state.quickComments = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = statusCommentsSlice;
// Extract and export each action creator by name
export const {
  fetchQuickStatusCommentsSuccess,
  fetchQuickStatusCommentsFailure,
  setLoadingComments,
  sortQuickStatusCommentsSuccess,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
